import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["tabindex", "disabled"];
var _hoisted_2 = { class: "calendar-day__inner" };
var _hoisted_3 = { class: "calendar-day__inner__viewbox" };
var _hoisted_4 = { class: "calendar-day__date" };
var _hoisted_5 = {
    key: 0,
    class: "calendar-day__extra"
};
import { inject } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CalendarDay',
    props: {
        day: {},
        isDisabled: { type: Boolean },
        daySelectedState: {},
        allowDaysOutOfDisplayedMonth: { type: Boolean }
    },
    setup: function (__props) {
        var getDayClass = inject('getDayClass');
        var getDayExtra = inject('getDayExtra');
        return function (_ctx, _cache) {
            var _a;
            var _b, _c, _d;
            return (_openBlock(), _createElementBlock("div", {
                role: "button",
                tabindex: _ctx.isDisabled ? -1 : 0,
                disabled: _ctx.isDisabled,
                class: _normalizeClass((_a = {
                        'calendar-day': true,
                        disabled: _ctx.isDisabled,
                        'not-in-month-shown': !((_b = _ctx.day) === null || _b === void 0 ? void 0 : _b.inDisplayedMonth) && _ctx.allowDaysOutOfDisplayedMonth,
                        'not-in-month-hidden': !((_c = _ctx.day) === null || _c === void 0 ? void 0 : _c.inDisplayedMonth) && !_ctx.allowDaysOutOfDisplayedMonth
                    },
                    _a[_ctx.daySelectedState] = !!_ctx.daySelectedState,
                    _a[_unref(getDayClass) ? _unref(getDayClass)(_ctx.day) : ''] = !!_unref(getDayClass),
                    _a))
            }, [
                _createElementVNode("span", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString((_d = _ctx.day) === null || _d === void 0 ? void 0 : _d.date.getDate()), 1 /* TEXT */),
                        (_unref(getDayExtra) && _ctx.day)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(getDayExtra)(_ctx.day)), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                        _renderSlot(_ctx.$slots, "default", { day: _ctx.day })
                    ])
                ])
            ], 10 /* CLASS, PROPS */, _hoisted_1));
        };
    }
});
